import React from "react";
import { Route, useHistory } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const password = process.env.REACT_APP_LOGIN_KEY;
  const passKey = localStorage.getItem("speedoc-private-login-pwd");
  const path = `/login?redirect=${encodeURIComponent(rest.location.pathname)}`;
  return <Route {...rest} render={props => (passKey === password ? <Component {...rest} /> : history.push(path))} />;
};

export default PrivateRoute;
